import { createContext, useContext, useState, useEffect } from "react";

const QuizContext = createContext();

export const QuizProvider = ({ children }) => {
  const [tabletSolved, setTabletSolved] = useState(false);

  // 🔹 컴포넌트가 처음 렌더링될 때 localStorage에서 값 불러오기
  useEffect(() => {
    const saved = localStorage.getItem("tabletSolved");
    if (saved === "true") {
      setTabletSolved(true);
    }
  }, []);

  // 🔹 tabletSolved가 변경되면 localStorage에 저장
  useEffect(() => {
    localStorage.setItem("tabletSolved", tabletSolved);
  }, [tabletSolved]);

  return (
    <QuizContext.Provider value={{ tabletSolved, setTabletSolved }}>
      {children}
    </QuizContext.Provider>
  );
};

export const useQuiz = () => useContext(QuizContext);
